import { z } from 'zod';

export const contactSchema = z.object({
  fullName: z.string().min(2, 'Please enter your full name.'),
  email: z.email('Please enter a valid email address.'),
  phone: z.string().max(30).optional(),
  company: z.string().max(120).optional(),
  jobTitle: z.string().max(120).optional(),
  reason: z.string().min(1, 'Please choose a reason for contact.'),
  subject: z.string().min(3, 'Please enter a subject.'),
  message: z.string().min(20, 'Please provide at least 20 characters.'),
  website: z.string().max(0, 'Spam detected.').optional(),
});
